import { useMemo } from 'react';
import { safeParseJSON } from 'framework-listing-lib/utils/json';
import useObjectTypeId from 'framework-listing-lib/internal/hooks/useObjectTypeId';
import { useViewsNamespace } from 'framework-listing-lib/internal/ViewTabs/hooks/useViewProps';
import useFetchUserSettings from 'framework-listing-lib/internal/userSettings/hooks/useFetchUserSettings';
export function useGetRecentFolderSettingKey() {
  const objectTypeId = useObjectTypeId();
  const namespace = useViewsNamespace();
  return useMemo(() => `recentFolders_${objectTypeId}_${namespace}`, [objectTypeId, namespace]);
}
export default function useFetchRecentFolders() {
  const settingKey = useGetRecentFolderSettingKey();
  const {
    data,
    loading
  } = useFetchUserSettings(settingKey, {
    defaultValue: '[]'
  });
  return {
    loading,
    recentFolders: data ? safeParseJSON(data.value, []) : []
  };
}